<script>
import LogoApp from "@/components/logo.vue"
import ElementAside from "@/components/admin/aside/ElementAside.vue"
const elements = [
  {
    label: 'Dashboard',
    icon: 'fa-solid fa-house',
    url: 'app_admin'
  },
  {
    label: 'Catégorie',
    icon: 'fa-solid fa-layer-group',
    url: 'app_admin_category'
  },
  {
    label: 'Produit',
    icon: 'fa-solid fa-wine-bottle',
    url: 'app_admin_product'
  },
  {
    label: 'Commandes',
    icon: 'fa-solid fa-check-to-slot',
    url: 'app_admin_order'
  },
  {
    label: 'Retour vers le site',
    icon: 'fa-solid fa-rotate-left',
    url: 'app_home'
  }
]
export default {
  name: 'HeaderAdmin',
  components: { ElementAside, LogoApp },
  data () {
    return {
      elements,
      viewAside: false
    }
  }
}
</script>

<template>
  <aside id="default-sidebar" :class="`fixed top-0 left-0 z-40 w-64 h-screen transition-transform ${viewAside ? '' : '-translate-x-full'} sm:translate-x-0`">
    <div class="overflow-y-auto py-5 px-3 h-full bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700">
      <logo-app />
      <ul @click="viewAside = !viewAside" class="space-y-2">
        <element-aside v-for="(element, index) in elements" :key="index" :url="element.url" :icon="element.icon" :label="element.label" />
      </ul>
    </div>
  </aside>
  <button @click="viewAside = !viewAside" :style="viewAside ? 'transform: translateX(65vw);' : ''" class="inline-flex items-center p-2 ml-1 text-xl w-10 text-gray-500 rounded-lg lg:hidden hover:bg-gray-100">
    <i v-if="!viewAside" class="fa-solid fa-bars"></i>
    <i v-else class="fa-solid fa-xmark"></i>
  </button>
</template>

<style scoped>

</style>